import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import Header from "components/headers/dark.js";
import Footer from "components/footers/FiveColumn.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
import { SectionHeading } from "components/misc/Headings.js";
import { PrimaryButton } from "components/misc/Buttons.js";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-1.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-2.svg";

const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col lg:flex-row items-center max-w-screen-xl mx-auto py-20 md:py-24`;
const LeftColumn = tw.div`relative lg:w-6/12 lg:pr-12 flex-shrink-0 text-center lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex flex-col justify-center`;

const Heading = tw(SectionHeading)`w-full`;
const Paragraph = tw.p`my-5 lg:my-8 text-base xl:text-lg`;

const IllustrationContainer = tw.div`flex justify-center lg:justify-end items-center`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none opacity-5 absolute left-0 top-0 h-64 w-64 transform -translate-x-2/3 -z-10`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none fill-current text-primary-500 opacity-25 absolute w-32 h-32 right-0 bottom-0 transform translate-x-32 translate-y-12 -z-10`}
`;

const Features = tw.div`mt-10 lg:mt-0`;
const Feature = tw.div`flex items-center text-lg`;
const FeatureIcon = tw.div`mr-4`;
const FeatureText = tw.div`text-gray-700`;

export default function MyFit() {
  return (
    <AnimationRevealPage>
      <Header />
      <MainFeature1
        subheading={<Subheading>Coming Soon</Subheading>}
        heading="MyFit - Your Personal Fitness Revolution"
        description="Experience the future of fitness with MyFit - your all-in-one solution for achieving your health and wellness goals. Powered by cutting-edge AI technology, we're bringing you a revolutionary platform that combines personalized coaching, smart tracking, and community support."
        buttonRounded={false}
        primaryButtonText="Join Waitlist"
        primaryButtonUrl="#"
        imageSrc="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
      />
      <MainFeature2
        subheading={<Subheading>Key Features</Subheading>}
        heading="Transform Your Fitness Journey"
        description="Our comprehensive platform combines cutting-edge technology with expert knowledge to provide you with everything you need to achieve your fitness goals."
        stats={[
          {
            key: "AI Coaches",
            value: "24/7",
          },
          {
            key: "Gym Partners",
            value: "1000+",
          },
          {
            key: "Success Rate",
            value: "95%",
          },
        ]}
        imageSrc="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
      />
      <Container>
        <TwoColumn>
          <LeftColumn>
            <Heading>
              Smart Features for Modern Fitness
            </Heading>
            <Features>
              <Feature>
                <FeatureIcon>🤖</FeatureIcon>
                <FeatureText>AI-Powered Personal Coaches</FeatureText>
              </Feature>
              <Feature>
                <FeatureIcon>🎯</FeatureIcon>
                <FeatureText>Smart Calorie & Exercise Tracking</FeatureText>
              </Feature>
              <Feature>
                <FeatureIcon>🏋️‍♂️</FeatureIcon>
                <FeatureText>Connect with Local Gyms</FeatureText>
              </Feature>
              <Feature>
                <FeatureIcon>🥗</FeatureIcon>
                <FeatureText>Personalized Diet Plans</FeatureText>
              </Feature>
              <Feature>
                <FeatureIcon>📊</FeatureIcon>
                <FeatureText>Progress Analytics & Insights</FeatureText>
              </Feature>
              <Feature>
                <FeatureIcon>👥</FeatureIcon>
                <FeatureText>Community Challenges & Support</FeatureText>
              </Feature>
            </Features>
          </LeftColumn>
          <RightColumn>
            <IllustrationContainer>
              <img
                src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
                alt="Fitness Features"
                tw="rounded-lg shadow-2xl"
              />
            </IllustrationContainer>
          </RightColumn>
        </TwoColumn>
      </Container>
      <MainFeature1
        subheading={<Subheading>Why Choose MyFit?</Subheading>}
        heading="The Future of Fitness is Here"
        description="MyFit combines the power of artificial intelligence with expert fitness knowledge to create a personalized experience that adapts to your needs. Whether you're a beginner or a fitness enthusiast, our platform provides the tools and support you need to achieve your goals."
        displayButton={false}
        imageSrc="https://images.unsplash.com/photo-1571902943202-507ec2618e8f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
      />
      <Footer />
    </AnimationRevealPage>
  );
} 